import { DocumentActionType } from '@payaca/types/documentActionsTypes';
import type { Document } from '@payaca/types/documentTypes';

export const getAvailableActionsForDocument = (
  canSendDocument: boolean,
  document?: Document
): DocumentActionType[] => {
  const documentActionTypes: DocumentActionType[] = [];

  if (!document || !!document?.archivedAt) {
    return documentActionTypes;
  }

  documentActionTypes.push(DocumentActionType.PRINT);

  if (document?.revisedAt) {
    return documentActionTypes;
  }

  documentActionTypes.push(DocumentActionType.EDIT);
  if (canSendDocument) {
    documentActionTypes.push(DocumentActionType.SEND_A_COPY);
  }
  return documentActionTypes;
};
